import React from 'react';
import Anchor from '../../../components/link/Anchor';
import AuthForm from '../AuthForm';
import './FormWrap.scss';

const FormWrap = (props) => {
  const { form, authData, setData, onLogin } = props;

  const AMONDZ_SERVICE_LIST = [
    {
      name: '운영 서비스',
      urlList: [
        'https://admin.amondz.com',
        'https://one.amondz.com',
        'https://fif.amondz.com',
        'https://nest.amondz.com',
      ],
    },
    {
      name: 'QA',
      urlList: ['https://qaadmin.qa-amondz.com', 'https://qaone.qa-amondz.com', 'https://qafif.qa-amondz.com'],
    },
    {
      name: 'DEV',
      urlList: ['https://devadmin.dev-amondz.com', 'https://devone.dev-amondz.com', 'https://devfif.dev-amondz.com'],
    },
  ];

  return (
    <div className="landing-template">
      <div className="content">
        <div className="wrap">
          <div className="left">
            <h1>AMONDZ</h1>
            {AMONDZ_SERVICE_LIST.map((item, index) => (
              <div key={index}>
                <div className="info">{item.name}</div>
                <ul>
                  {item.urlList.map((url, _index) => (
                    <li key={_index}>
                      <Anchor text={url} href={url} target="_blank" />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="right">
            <h1>AMONDZ ADMIN 로그인</h1>
            <AuthForm form={form} authData={authData} setData={setData} onLogin={onLogin} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormWrap;
